<template>
  <v-dialog v-model="value" persistent :max-width="widhtDialog">
    <v-stepper v-model="stepper" alt-labels>
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">
          Escoger cliente
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 2" step="2">
          Especificar datos parte
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepper > 1 && isValid"
          :rules="[() => isValid]"
          step="3"
        >
          Validar contratos
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"> Resumen </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-autocomplete
            :loading="loadingClientes"
            :disabled="loadingClientes"
            v-model="clienteSeleccionado"
            :items="clientes.filter((c) => c.value !== cliente.cliente_id)"
            label="Selecciona un cliente..."
            return-object
            @input="validarContratosCliente($event)"
          >
          </v-autocomplete>
          <v-btn color="red" text @click="cerrar">Cancelar</v-btn>
          <v-btn
            color="primary lighten--1"
            text
            @click="incrementarStepper()"
            :disabled="clienteSeleccionado == null"
            >Siguiente</v-btn
          >
          <!-- :disabled="cliente == null" -->
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="delegacionSeleccionada"
                  :loading="loadingDelegaciones"
                  :disabled="loadingDelegaciones"
                  :items="delegaciones"
                  item-text="direccion"
                  item-value="delegacionId"
                  return-object
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Delegación
                  </template>
                </v-select>
                <!-- label="Delegación" -->
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  :loading="loadingContratosDisponibles"
                  :disabled="loadingContratosDisponibles"
                  v-model="tipoParte"
                  :items="contratosDisponibles"
                  label="Restricción contrato"
                  item-text="contrato"
                  item-value="id"
                  return-object
                  clearable
                  @input="validarContratosTipoParte($event)"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="tecnico"
                  :items="tecnicos"
                  chips
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Técnico
                    asignado
                  </template>
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected">
                      <v-avatar left :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-avatar>
                      {{ data.item.nombre + " " + data.item.apellidos }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          data.item.nombre
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          data.item.apellidos
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="comercial"
                  :items="comerciales"
                  chips
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Comercial
                    asignado
                  </template>
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected">
                      <v-avatar left :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-avatar>
                      {{ data.item.nombre + " " + data.item.apellidos }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          data.item.nombre
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          data.item.apellidos
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-btn color="red" text @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary lighten--1" text @click="decrementarStepper()"
            >Atrás</v-btn
          >
          <v-btn
            color="primary lighten--1"
            text
            @click="incrementarStepper()"
            :loading="loadingValidacion"
            :disabled="
              clienteSeleccionado == null ||
              delegacionSeleccionada == null ||
              loadingValidacion
            "
          >
            Siguiente
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <ValidaContratosAcciones></ValidaContratosAcciones>
          <v-btn color="red" text @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary lighten--1" text @click="decrementarStepper()"
            >Atrás</v-btn
          >
          <v-btn
            color="primary lighten--1"
            text
            @click="incrementarStepper()"
            :disabled="
              clienteSeleccionado == null ||
              delegacionSeleccionada == null ||
              !isValid
            "
          >
            Siguiente
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="4" class="pt-4">
          <v-row>
            <!-- ANTES Cambios de la cabecera del parte -->
            <v-col cols="12" sm="6">
              <v-card class="mb-4 mx-2">
                <v-card-subtitle class="text-subtitle-2"
                  >Datos del parte antes del cambio</v-card-subtitle
                >
                <div class="px-5">
                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Cliente"
                        :value="`${cliente.cliente_id} - ${cliente.cliente_nombre}`"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Delegación"
                        :value="delegacion.direccion"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Restricción contrato"
                        :value="
                          tipoParte_contrato
                            ? tipoParte_contrato.contrato
                            : null
                        "
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Técnico"
                        :value="userNameById(tecnico_id)"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Comercial"
                        :value="userNameById(comercial_id)"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
            <!--  DESPUES Cambios de la cabecera del parte -->
            <v-col cols="12" sm="6">
              <v-card class="mb-4 mx-2">
                <v-card-subtitle class="text-subtitle-2"
                  >Datos del parte después del cambio</v-card-subtitle
                >
                <div class="px-5">
                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Cliente"
                        :value="
                          clienteSeleccionado
                            ? `${clienteSeleccionado.value} - ${clienteSeleccionado.text}`
                            : null
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Delegación"
                        :value="
                          delegacionSeleccionada
                            ? delegacionSeleccionada.direccion
                            : null
                        "
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Restricción contrato"
                        :value="tipoParte ? tipoParte.contrato : null"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Técnico"
                        :value="userNameById(tecnico)"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        readonly
                        label="Comercial"
                        :value="userNameById(comercial)"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="accionesNoValidas.length">
            <!-- ANTES ACCIONES -->
            <v-col cols="12" sm="6">
              <v-card class="mb-4 mx-2">
                <v-card-subtitle class="text-subtitle-2"
                  >Acciones antes del cambio</v-card-subtitle
                >
                <!-- <div class="px-5"> -->
                <v-data-table
                  :headers="headers2"
                  :items="acciones"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :page.sync="page"
                  :items-per-page.sync="itemsPerPage"
                >
                  <!-- Técnico -->
                  <template v-slot:item.user.name="{ item }">
                    <v-chip outlined>
                      <v-avatar left :color="item.user.color">
                        <span class="white--text">
                          {{ item.user.avatar }}
                        </span>
                      </v-avatar>
                      {{ item.user.name }}
                    </v-chip>
                  </template>

                  <!-- Fecha -->
                  <template v-slot:item.fecha="{ item }">
                    {{ formatDate(item.fecha) }}
                  </template>

                  <!-- Comentarios -->
                  <template v-slot:item.comentarios="{ item }">
                    <v-textarea
                      v-model="item.comentarios"
                      readonly
                      hide-details
                      rows="1"
                    ></v-textarea>
                  </template>

                  <!-- Desplazamiento -->
                  <template v-slot:item.desplazamiento="{ item }">
                    <v-checkbox
                      v-model="item.desplazamiento"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Fura horas -->
                  <template v-slot:item.fuera_horas="{ item }">
                    <v-checkbox
                      v-model="item.fuera_horas"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Asistencia minia -->
                  <template v-slot:item.asistencia_minima="{ item }">
                    <v-checkbox
                      v-model="item.asistencia_minima"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Abono -->
                  <template v-slot:item.abono="{ item }">
                    <v-checkbox v-model="item.abono" disabled></v-checkbox>
                  </template>

                  <!-- APV -->
                  <template v-slot:item.apv="{ item }">
                    <v-checkbox v-model="item.apv" disabled></v-checkbox>
                  </template>
                </v-data-table>
                <!-- </div> -->
              </v-card>
            </v-col>
            <!-- DESPUES ACCIONES -->
            <v-col cols="12" sm="6">
              <v-card class="mb-4 mx-2">
                <v-card-subtitle class="text-subtitle-2"
                  >Acciones después del cambio</v-card-subtitle
                >
                <v-data-table
                  :headers="headers2"
                  :items="resumenAcciones"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :page.sync="page"
                  :items-per-page.sync="itemsPerPage"
                >
                  <!-- Técnico -->
                  <template v-slot:item.user.name="{ item }">
                    <v-chip outlined>
                      <v-avatar left :color="item.user.color">
                        <span class="white--text">
                          {{ item.user.avatar }}
                        </span>
                      </v-avatar>
                      {{ item.user.name }}
                    </v-chip>
                  </template>

                  <!-- Fecha -->
                  <template v-slot:item.fecha="{ item }">
                    {{ formatDate(item.fecha) }}
                  </template>

                  <!-- Comentarios -->
                  <template v-slot:item.comentarios="{ item }">
                    <v-textarea
                      v-model="item.comentarios"
                      readonly
                      hide-details
                      rows="1"
                    ></v-textarea>
                  </template>

                  <!-- Desplazamiento -->
                  <template v-slot:item.desplazamiento="{ item }">
                    <v-checkbox
                      v-model="item.desplazamiento"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Fura horas -->
                  <template v-slot:item.fuera_horas="{ item }">
                    <v-checkbox
                      v-model="item.fuera_horas"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Asistencia minia -->
                  <template v-slot:item.asistencia_minima="{ item }">
                    <v-checkbox
                      v-model="item.asistencia_minima"
                      disabled
                    ></v-checkbox>
                  </template>

                  <!-- Abono -->
                  <template v-slot:item.abono="{ item }">
                    <v-checkbox v-model="item.abono" disabled></v-checkbox>
                  </template>

                  <!-- APV -->
                  <template v-slot:item.apv="{ item }">
                    <v-checkbox v-model="item.apv" disabled></v-checkbox>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" class="text-center">
              <v-alert
                dense
                outlined
                border="left"
                class="mx-2 text-center my-0"
                color="info"
              >
                <p class="body-2 mb-0">
                  <v-icon color="info" class="mr-2"
                    >mdi-information-outline</v-icon
                  >
                  No se ha tenido que cambiar ninguna acción
                </p>
              </v-alert>
            </v-col>
          </v-row>

          <v-btn color="red" text @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary lighten--1" text @click="decrementarStepper()"
            >Atrás</v-btn
          >
          <v-btn
            color="primary lighten--1"
            text
            @click="confirmar()"
            :disabled="
              clienteSeleccionado == null ||
              delegacionSeleccionada == null ||
              !isValid
            "
          >
            Confirmar
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import axios from "axios";

import { mapActions, mapGetters } from "vuex";
import ValidaContratosAcciones from "./ValidaContratosAcciones";
import formatearFecha from "../../mixins/formatearFecha";
const defaultWidth = "95vw";
const widths = {
  1: "60vw",
  2: "70vw",
};
export default {
  mixins: [formatearFecha],
  data() {
    return {
      clienteSeleccionado: null,
      delegaciones: [],
      loadingDelegaciones: false,
      delegacionSeleccionada: null,
      stepper: 1,
      maxSteps: 4,
      comercial: null,
      tecnico: null,
      resumenAcciones: [],
      loadingContratosDisponibles: false,
      contratosDisponibles: [],
      tipoParte: null,

      sortBy: null,
      sortDesc: false,
      page: 1,
      itemsPerPage: 10,
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    tecnico_id: {
      type: Number,
      required: true,
    },
    comercial_id: {
      type: Number,
      required: true,
    },
    acciones: {
      type: Array,
      required: true,
    },
    tipoParte_id: {
      type: null,
      required: true,
    },
    tipoParte_contrato: {
      type: null,
      required: true,
    },
    cliente: {
      type: Object,
      required: true,
    },
    delegacion: {
      type: null,
      required: true,
    },
  },
  methods: {
    ...mapActions(["setSnackbar"]),
    ...mapActions("acciones", ["getHeaders"]),
    cargarContratosDisponibles() {
      this.loadingContratosDisponibles = true;
      axios
        .get(`/api/contratos?codCliente=${this.clienteSeleccionado.value}`)
        .then((res) => {
          this.contratosDisponibles = res.data.filter(
            (contrato) => contrato.activo
          );
        })
        .catch(() => {
          this.setSnackbar({
            snackbar: true,
            tipo: "error",
            mensaje: "Error. No se han podido cargar los contratos del cliente",
          });
        })
        .finally(() => {
          this.loadingContratosDisponibles = false;
        });
    },
    validarAcciones() {
      this.$store.dispatch("moverAcciones/setAccionesNoValidas", {
        acciones: this.acciones,
      });
    },
    validarContratosCliente(event) {
      this.validarContratos(event.value, this.tipoParte_id);
    },
    validarContratosTipoParte(event) {
      const tipoParte = event === undefined ? null : event.id;
      this.validarContratos(this.clienteSeleccionado.value, tipoParte);
    },
    validarContratos(cliente, tipoParte_id) {
      this.$store
        .dispatch("moverAcciones/getContratosValidos", {
          cliente: cliente,
          tipoParte_id: tipoParte_id,
        })
        .then(() => {
          this.validarAcciones();
        })
        .finally(() => {
          this.loadingPartes = false;
        });
    },
    async cargarDelegaciones() {
      this.delegacionSeleccionada = null;
      this.delegaciones = [];
      this.loadingDelegaciones = true;
      let respuestaDelegaciones = await axios.get(
        `/api/delegaciones?codCliente=${this.clienteSeleccionado.value}`
      );
      this.delegaciones = respuestaDelegaciones.data;
      if (this.delegaciones.length == 1)
        this.delegacionSeleccionada = this.delegaciones[0];
      this.loadingDelegaciones = false;
    },
    incrementarStepper() {
      if (this.stepper <= this.maxSteps) this.stepper += 1;
      switch (this.stepper) {
        case 2:
          this.cargarDelegaciones();
          this.cargarContratosDisponibles();
          if (this.tipoParte_id) this.tipoParte = this.tipoParte_id;
          if (this.tecnico_id) this.tecnico = this.tecnico_id;
          if (this.comercial_id) this.comercial = this.comercial_id;
          break;
        case 3:
          if (this.isValid) this.incrementarStepper();
          break;
        case 4:
          this.prepararResumenAcciones();
          break;
        default:
          break;
      }
    },

    decrementarStepper() {
      if (this.stepper > 1) this.stepper -= 1;
      switch (this.stepper) {
        case 1:
          this.delegacionSeleccionada = null;
          this.delegaciones = [];
          break;
        case 2:
          this.validarAcciones();
          this.$store.dispatch("moverAcciones/setAccionesEditadas", {
            acciones: [],
          });

          break;
        case 3:
          break;
        default:
          break;
      }
    },
    prepararResumenAcciones() {
      this.resumenAcciones = this.acciones.filter(
        ({ id: id1 }) =>
          !this.accionesNoValidas.some(({ id: id2 }) => id2 === id1)
      );
      this.resumenAcciones.push(...this.accionesEditadas);
    },
    confirmar() {
      this.$emit("confirmar", {
        cliente: this.clienteSeleccionado,
        delegacionId: this.delegacionSeleccionada.delegacionId,
        user_id: this.tecnico,
        comercial_id: this.comercial,
        tipoParte_id: this.tipoParte ? this.tipoParte.id : null,
        acciones: this.accionesEditadas,
        // delegaciones: this.delegaciones,
      });
      this.cerrar();
    },
    reset() {
      this.stepper = 1;
      this.$store.dispatch("moverAcciones/reset");
      this.clienteSeleccionado = null;
      this.delegaciones = [];
      this.loadingDelegaciones = false;
      this.delegacionSeleccionada = null;
      this.resumenAcciones = [];
      this.loadingContratosDisponibles = false;
      this.contratosDisponibles = [];
      this.tipoParte = null;

      this.comercial = null;
      this.tecnico = null;
    },
    cerrar() {
      this.reset();
      this.$emit("input", false);
    },
  },
  computed: {
    ...mapGetters({
      headerAcciones: "acciones/headers",
      headers2: "acciones/headers2",
      clientes: "clientesDisponibles",
      loadingClientes: "loadingClientes",
      tecnicos: "usuarios/tecnicos",
      comerciales: "usuarios/comerciales",
      isValid: "moverAcciones/isValid",
      accionesNoValidas: "moverAcciones/accionesNoValidas",
      accionesEditadas: "moverAcciones/accionesEditadas",
      loadingValidacion: "moverAcciones/loadingValidacion",
      // usuerById: "usuarios/userById",
      userNameById: "usuarios/userNameById",
    }),
    // test() {
    //   this.getHeaders("tecnico", "fecha");
    // },

    widhtDialog() {
      return widths[this.stepper] ?? defaultWidth;
    },
  },
  mounted() {
    if (!this.clientes.length) {
      this.$store.dispatch("getClientesDisponibles");
    }
    if (!this.tecnicos.length || !this.tecnicos.length) {
      this.$store.dispatch("usuarios/getUsuarios");
    }
  },
  components: {
    ValidaContratosAcciones,
  },
};
</script>

<style>
</style>